import { Component } from '@angular/core';
import { Item } from 'src/app/models/item';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PolicyService } from 'src/app/services/policy.service';

@Component({
  selector: 'app-dashboard-agent-panel',
  templateUrl: './dashboard-agent-panel.component.html',
  styleUrls: ['./dashboard-agent-panel.component.css']
})
export class DashboardAgentPanelComponent {
  onBoardedAgent:number=0;
  onBoardedAgentRatio:number = 0;
  inProgressAgent:number=0;
  inProgressAgentRatio:number=0;
  blokedAgent:number=0;
  blokedAgentRatio:number=0;
  totalCustomers:number=0;
  totalCustomersRatio:number=0;
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  topRecentAgent:any=[];
  topPerfAgent:any=[];

  constructor(private policyService:PolicyService, private spinner: LoaderService, private dashboardSevice:DashboardService){

  }  

  bindDashboardAgentData(StartDate:string,EndDate:string,policyType:number){
    let obj={
      DistributorId:0,
      ResellerId:0,
      AgentId:0,
      SystemCompanyId:1,
      StartDate:StartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:EndDate,//moment(this.selectedEndDate).format('YYYY-MM-DD'),
      policyType:policyType,//this.policyType
    }    
    this.dashboardAgentStatus(obj);
    this.dashboardSevice.DashboardAgentTop5Performance(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
                this.topPerfAgent= JSON.parse(response.result[i]);            
              break;
              case 1 :
                this.topRecentAgent= JSON.parse(response.result[i]);              
              break;
            }
            
          }
        } 
    
        if(this.topPerfAgent && this.topPerfAgent.length > 0)
        {
          this.graphHeader=Object.keys(this.topPerfAgent[0]).map((m:any)=>{return {key: m,type:"System.String"}});
          this.visibleColumnData =  this.graphHeader.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') });
          this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
          this.graphdata=this.topPerfAgent.map((m:any) => {return Object.values(m)});
        }
        else
        {
          this.graphHeader = [];
          this.visibleColumnData = [];
          this.visibleColumnsId = [];
          this.graphdata = [];
        }  
      }
    });
  }
  
  async dashboardAgentStatus(obj:any){
    this.dashboardSevice.DashboardAgentStatus(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
              this.onBoardedAgent= JSON.parse(response.result[i])[0].count;
              let onBoardedAgentOld = JSON.parse(response.result[i])[1].count;
              //this. onBoardedAgentRatio = getGrowthRatio((onBoardedAgentOld??0).toString(),(this.onBoardedAgent??0).toString());
              break;
              case 1 :
              this.inProgressAgent= JSON.parse(response.result[i])[0].count;
              let inProgressAgentOld= JSON.parse(response.result[i])[1].count;
              //this.inProgressAgentRatio = getGrowthRatio((inProgressAgentOld??0).toString(),(this.inProgressAgent??0).toString());
              break;
              case 2 :
              this.blokedAgent= JSON.parse(response.result[i])[0].count;
              let blokedAgentOld= JSON.parse(response.result[i])[1].count;
              //this.blokedAgentRatio = getGrowthRatio((blokedAgentOld??0).toString(),(this.blokedAgent??0).toString());
              break;
              case 3 :
              this.totalCustomers= JSON.parse(response.result[i])[0].count;
              let totalCustomersOld = JSON.parse(response.result[i])[1].count;
              //this.totalCustomersRatio = getGrowthRatio((totalCustomersOld??0).toString(),(this.totalCustomers??0).toString());
              break;
            }
            
          }
        } 
      }
    });
  }
}
